export * from './holdersDetail';
